module.exports = __webpack_public_path__ + "static/media/flow.3ee684cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/flow.png
// module id = 781
// module chunks = 0